<template>
  <div class="TreeComponent">

    <p>{{lang.infotext_1}}</p>
    <b-form-input class="searchInput" id="input-search" size="sm" v-model="searchString" :placeholder="lang.placeholder_Search"></b-form-input>
    <br>
    <ul v-if="isData"  :id="id" class="library_ul">
      <ItemTree :action="action" :lang="lang.TreeItem" :searchString="searchString"  class="item"   :model="dataTree"  :edit="iscategory" ></ItemTree>
    </ul>
    <LoaderComponent  v-if="!isData"></LoaderComponent>

 </div>
</template>

<script>
import ItemTree from "@/components/shared/ItemTree"
import LoaderComponent from "@/components/shared/LoaderComponent"
import { mapGetters } from 'vuex'


export default {
  name: 'TreeComponent',
  components: {
    ItemTree,
    LoaderComponent
  },
  props:{
      iscategory: Boolean,
      reloadTree: Boolean,
      lang: Object,
      action: Boolean
  },
  data: function () {
      return {
          open: true,
          dataItem:{},

          id: "tree_"+this._uid,
          name:'',
          searchString: ""

      };
  },
  computed: {

    ...mapGetters({
      dataTree: 'dataTree',
      reloadAfterDeleteTreeItem: 'reloadAfterDeleteTreeItem',
      
    }),
    isData(){


      return this.$store.getters.dataTree.name != ""
    }
  },
  watch: {
         
    reloadAfterDeleteTreeItem: function(new_isData)
    {
      if (new_isData)
      {
        this.loadData();
        this.$store.dispatch("reloadAfterDeleteTreeItem",false )
      }
    },

    reloadTree: function()
    {
      this.loadData();
    }
  },
  mounted () {
    
    
  },
  created () {
    

    this.$store.dispatch("deleteCategoryMapping");

    this.loadData();

    //this.setCategory();
  },
  updated() {
    
  },
  methods: {
    loadData(){
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getCategories", this.id);
    }

  }
}
</script>


<style lang="scss">
.library_bold {
    font-weight: bold;
  }

  .library_ul label{
    margin-right: 0px;
  }
  .library_li{
    margin-top: 5px;
    margin-left: 0px;
    width: 100%;

  }
  .library_img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
  }
  .library_ul {
    padding-left: 18px;
    line-height: 1.5em;
    list-style-type: none;

  }
  .searchInput{
    font-size: 0.75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/TreeComponent.vue